import { Unit } from '@dynatrace-sdk/units';

import { TooltipValueMetadata } from '../../../types/histogram.js';

export function getAbsoluteValue(
  absoluteMetadata: TooltipValueMetadata,
  formatter: (value: number, unit?: string | Unit) => string,
) {
  return absoluteMetadata?.unit
    ? formatter(absoluteMetadata.value, absoluteMetadata.unit)
    : absoluteMetadata.value;
}
